export default __webpack_public_path__ + "static/media/Velocity-Home_03.06676cbd.png";